import React from 'react';
import { ResetPasswordContainer } from '../../containers/ResetPasswordContainer/ResetPasswordContainer';
import withContentLayout from '../../hoc/withContentLayout';

const ResetPassword = (props) => {
  return <ResetPasswordContainer {...props} />;
};

export default withContentLayout(ResetPassword);
